// src/pages/controleBar/comandas/ImprimirResumoModal.js
import React, { useState } from "react";
import ModalContainer from "../../../components/modalForm/ModalContainer";
import ModalHeader from "../../../components/modalForm/ModalHeader";
import ModalBody from "../../../components/modalForm/ModalBody";
import { FiPrinter } from "react-icons/fi";
import { usePrinterComanda } from "../../../contexts/geral/PrinterComandaContext";

const ImprimirResumoModal = ({ open, onClose, comandas }) => {
  const [selecionadas, setSelecionadas] = useState([]);
  const { printResumoComandasPDF } = usePrinterComanda();

  const toggleComanda = (id) => {
    setSelecionadas((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleConfirm = async () => {
    const selecionadasCompletas = comandas.filter((c) =>
      selecionadas.includes(c.id)
    );
    await printResumoComandasPDF(null, selecionadasCompletas);
    onClose();
  };

  return (
    <ModalContainer show={open} onClose={onClose} maxWidth="500px">
      <ModalHeader>
        <h5>Imprimir Resumo das Comandas</h5>
        <button className="btn-close" onClick={onClose}></button>
      </ModalHeader>

      <ModalBody>
        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
          {comandas.map((c) => (
            <div key={c.id} style={{ marginBottom: 6 }}>
              <label>
                <input
                  type="checkbox"
                  checked={selecionadas.includes(c.id)}
                  onChange={() => toggleComanda(c.id)}
                  style={{ marginRight: 8 }}
                />
                Comanda #{c.codigo} – {c.nomeCliente}
              </label>
            </div>
          ))}
        </div>

        {/* ✅ Botões alinhados */}
        <div
          style={{
            marginTop: 20,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* Botão cancelar */}
          <button
            onClick={onClose}
            style={{
              backgroundColor: "#ccc",
              color: "#333",
              padding: "8px 16px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Cancelar
          </button>

          {/* Botão imprimir */}
          <button
            onClick={handleConfirm}
            disabled={selecionadas.length === 0}
            style={{
              backgroundColor: selecionadas.length === 0 ? "#8bbbe7" : "#007bff",
              color: "white",
              padding: "8px 18px",
              border: "none",
              borderRadius: "6px",
              cursor: selecionadas.length === 0 ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontWeight: "bold",
            }}
          >
            <FiPrinter size={18} />
            Imprimir Selecionadas
          </button>
        </div>
      </ModalBody>
    </ModalContainer>
  );
};

export default ImprimirResumoModal;
